import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthServiceService } from '../services/auth-service.service';
import { IUserProfile} from '../interfaces/IUserProfile.interface'
import { UserProfile} from '../models/UserProfile';
import { PwrDetails } from '../models/PwrDetails';


@Component({
  selector: 'app-pwr',
  templateUrl: './pwr.component.html',
  styleUrls: ['./pwr.component.css']
})
export class PwrComponent implements OnInit {

	isAuthenticated: boolean = false;
	myTempId: string = "";
	message: string = "";
	accepted: boolean = false;
	resetResult: boolean = false;
	details: PwrDetails;
	newPass: string;
	confirmPass: string;
	
	constructor(private authService: AuthServiceService, private router: Router, private route: ActivatedRoute) { }

	ngOnInit() {
		if(this.route.snapshot.paramMap.get('id')){
	      	this.myTempId = this.route.snapshot.paramMap.get('id');

	      	this.authService.CheckTempIdExpiration(this.myTempId).subscribe(
        	result => {
    			if(!result){
					this.message = "The reset link you used has expired, please request a new password reset.";
					this.accepted = false;
    			}
    			else 
    				this.accepted = true;
    	});
	    }
	    else{
			this.router.navigate(['/login']);
	    }

	    
	}

	SavePwrChange(){
		this.details = new PwrDetails();
		this.details.newPass = this.newPass;
		this.details.ConfirmPass = this.confirmPass;
		this.details.TempId = this.myTempId;

		this.authService.ResetPassword(this.details).subscribe(
			resp => {
				if(resp == 'Reset completed Successfully.'){
					this.resetResult = true;
				}
				else {
					this.resetResult = false;
				}
		});
	}

	navigateToLogin(){
	  	this.router.navigate(['/login']);
	}

}



// WEBPACK FOOTER //
// ./src/app/pwr/pwr.component.ts